module.exports = __webpack_public_path__ + "img/fgyl.f79e72d1.png";